
<div class="modal-dialog confirm-dialog" style="min-width:850px;">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-12 mt-4">
        <h4 class="modal-title d-inline-block">Existing Fleet</h4>
        <button class="btn btn-outline-primary float-right" (click)="addNewFleet()" [disabled]="disableAddNewFleetButton">Add New Fleet</button>
      </div>
      <button class="close" type="button" (click)="cancel()" style="margin: -1.5rem -1rem -1rem -1.5rem;">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="fleetFiltered.length" (onChange)="onListControlsChange($event)"></list-controls>
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr class="text-left align-top" *ngIf="!!fleetToShow.length">
            <th style="background: #EAF7FF; color: #a5a5a5; font-weight: normal;">Fleet Name</th>
            <th style="background: #EAF7FF; color: #a5a5a5; font-weight: normal;">Fleet ID</th>
          </tr>
        </thead>
        <tbody>
          <ng-template [ngIf]="!loading &amp;&amp; fleetFiltered.length">
            <tr *ngFor="let fleet of fleetFiltered; index as i" [ngClass]="{'disabled-content': fleet.disabled}">
              <td class="td-width">
                <div class="form-group form-check m-0">
                  <input class="form-check-input" type="radio" (change)="changeFleetSelection(fleet.uniqueId)" value="{{fleet.uniqueId}}" id="fleet-selection-radio-{{i}}" name="selectFleetGroup" [checked]="fleet.uniqueId === selectedFleetUniqueId" [disabled]="fleet.disabled">
                  <label class="form-check-label m-0">{{ fleet.fleetName }}</label>
                </div>
              </td>
              <td>{{ fleet.fleetId }}</td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="!loading &amp;&amp; !fleetFiltered.length">
            <tr>
              <td colspan="8">
                <p class="text-center empty-table-message">There are no fleets to display.</p>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="loading">
            <tr>
              <td colspan="8">
                <md-spinner-block></md-spinner-block>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
    <div class="modal-footer" style="display: flex; justify-content: start;">
      <button class="btn btn-outline-secondary px-4 ml-auto" (click)="cancel()">Cancel</button>
      <button class="btn px-4" (click)="save()" [disabled]="selectedFleetUniqueId === ''" [ngClass]="selectedFleetUniqueId !== '' ? 'btn-outline-primary' : 'btn-outline-secondary'">Save</button>
    </div>
  </div>
</div>